<div class="db-cdn-notice" *ngIf="!hasDcvRecord && website?.cloudflareEnabled && (!isStatusPending || (isStatusPending && !!this.isNameServer))">
  <div class="ds-notification-error">
    <div class="db-icon-wrapper mt4 mr8"><i class="db-icon db-icon-ds-info-bg red mr4"></i></div>

    <p><b>You must follow these steps for full activation CDN</b><span>Cloudflare has released a new feature called DCV Delegation to automate the SSL certificate renewal process.<br/> Make sure to follow the steps on <span (click)="setActiveTab()" class="text-underline">Cloudflare CDN settings page</span> to ensure uninterrupted service of your website.</span>
    </p>
  </div>
</div>
